// extracted by mini-css-extract-plugin
export var legendIndicator = "_d2-1";
export var legendRight = "_d2-0";